<script>
import { mapActions } from 'vuex'
import get from 'lodash/get'
import categoryForm from './category-form'

export default {
  name: 'CategoryDetails',
  page: {
    title: 'Category Details',
  },
  components: {
    categoryForm,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      category: null,
      backRoute: { name: 'categories' },
      linkedRetailers: [],
    }
  },
  computed: {
    categoryName() {
      return get(this.category, 'name')
    },
    retailersTitle() {
      return this.linkedRetailers.length ? 'Linked Retailers' : 'No linked Retailers'
    },
  },
  created() {
    this.fetchCategory()
  },
  methods: {
    ...mapActions('category', ['getCategory']),
    ...mapActions('retailer', ['getRetailers']),
    async fetchCategory() {
      const [err, category] = await this.getCategory(this.id)

      if (err) {
        this.$router.replace(this.backRoute)
      } else {
        this.category = category
      }

      if (category.retailersCount) {
        const [, retailers] = await this.getRetailers()

        this.linkedRetailers = get(retailers, 'items', [])
          .filter(retailer => get(retailer, 'category.name') === this.categoryName)
      }

      this.loading = false
    },
  },
}
</script>

<template>
  <main-layout
    :title="categoryName"
    :loading="loading"
    :back="backRoute"
  >
    <data-box :status="false">
      <category-form :category="category" />

      <div>
        <p :class="$style.title">
          {{ retailersTitle }}
        </p>
        <template v-if="linkedRetailers">
          <router-link
            v-for="retailer in linkedRetailers"
            :key="retailer.id"
            :class="$style.retailer"
            :to="{
              name: 'retailer-details',
              params: { id: retailer.id }
            }"
          >
            {{ retailer.name }}
          </router-link>
        </template>
      </div>
    </data-box>
  </main-layout>
</template>

<style lang="scss" module>
.title {
  padding-top: 1rem;
  font-size: 1.2rem;
  font-weight: 700;
}

.retailer {
  display: block;
  margin-top: 1rem;
}
</style>
